module.exports = "\r\n<sm-frontend-top-menu class=\"no-sm-header\" *ngIf=\"!isSm\"></sm-frontend-top-menu>\r\n<sm-backend-top-menu class=\"sm-header\" *ngIf=\"isSm\"></sm-backend-top-menu>\r\n";


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/sm-nav-menu.component.html
// module id = 417
// module chunks = 11